const options = JSON.parse(`{"spa":"history","siteId":"PEDAXTUG","url":"https://cdn.usefathom.com/script.js","honorDNT":false,"includedDomains":["https://greenlinedcs.com/","localhost:3000"],"excludedDomains":["google.com"],"canonical":true,"namespace":"fathom"}`)
const { debug, namespace } = options

if (debug) {
  console.log(`DEBUG ENABLED - ${namespace} options: `, options)
}